import { render } from "./ExamPage.vue?vue&type=template&id=48cc95e6"
import script from "./ExamPage.vue?vue&type=script&lang=js"
export * from "./ExamPage.vue?vue&type=script&lang=js"

import "./ExamPage.vue?vue&type=style&index=0&id=48cc95e6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__